import React from "react";
import { Alert, Form, Icon, Button, Row, Col, Select } from "antd";
import { connect } from "react-redux";
import get from "lodash/get";

import { getUserToken } from "../../reducers/user/selectors";
import { updateConsentGivenRequest } from "../../api/requests";

import classes from "./PatientProfileForm.css";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class PatientEmailStatusForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      username: "",
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({
          isLoading: true,
          errorMessage: null,
          responseMessage: null,
        });

        try {
          await updateConsentGivenRequest(
            this.props.subjectID,
            values.custom_consent_given === "true"
              ? true
              : values.custom_consent_given === "false"
              ? false
              : null
          );

          this.setState({ responseMessage: "Success" });

          setTimeout(() => {
            this.props.onSubmit(this.props.subjectID);
          }, 1500);
        } catch (err) {
          this.setState({
            errorMessage: get(
              err,
              "response.data.msg",
              get(err, "response.data.errors._schema[0]", "Error")
            ),
            isLoading: false,
          });
        }
      }
    });
  };

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { isLoading, errorMessage, responseMessage } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={8}>
            <Col sm={6}>
              <label>
                <b>Custom consent given</b>
                <Form.Item>
                  {getFieldDecorator("custom_consent_given", {
                    initialValue: `${get(
                      this.props,
                      "custom_consent_given",
                      "null"
                    )}`,
                  })(
                    <Select>
                      <Option value="true">True</Option>
                      <Option value="false">False</Option>
                      <Option value="null">Null</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              className={classes.alertsMb}
            />
          )}
          {responseMessage && (
            <Alert
              message={responseMessage}
              type="success"
              className={classes.alertsMb}
            />
          )}

          {!responseMessage && (
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    disabled={hasErrors(getFieldsError())}
                    className={classes.submitButton}
                  >
                    Save
                    {isLoading && <Icon type="loading" />}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userToken: getUserToken(state),
});

export default Form.create({ name: "PatientEmailStatusForm" })(
  connect(mapStateToProps)(PatientEmailStatusForm)
);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientConsentGivenForm.js